import { RssItemDto } from "../types";
import { RssFetcher } from "../types";

type ThwackBlogItem = {
  name: string;
  url: string;
  category: {
    name: string;
    url: string;
  };
  countComments: number;
  countViews: number;
  dateLastComment?: string;
};

export const thwackBlogsJsonFetcher = (): RssFetcher => ({
  fetch: async (limit: number): Promise<RssItemDto[]> => {
    const response = await fetch("/api/thwack-blogs-json?limit=" + limit);

    if (!response.ok) {
      throw new Error(
        `Failed to fetch Thwack blogs JSON: ${response.statusText}`,
      );
    }

    const items = await response.json();

    return (items as ThwackBlogItem[]).map(
      (item): RssItemDto => ({
        title: item.name,
        link: item.url,
        tag: item.category.name,
        tagLink: item.category.url,
        replies: item.countComments,
        views: item.countViews,
        latestReply: item.dateLastComment
          ? new Date(item.dateLastComment)
          : undefined,
      }),
    );
  },
});
